// extracted by mini-css-extract-plugin
export default {"card":"style_card__Gt7AH","icon":"style_icon__z5C3q","title":"style_title__fZc+h","value":"style_value__7UHBc"};